<template>
  <div>
    <div class="page">
      <div class="content">
        <div class="header">
          <img src="../assets/img/logo.png" alt="">
          <span class="header-btn" style="background-color: #000099" @click="$toweb('https://bbs.wstx.com/thread-824717-1-1.html')">支持与下载</span>
          <span class="header-btn" @click="$toweb('https://realforce.tmall.com/')">立即购买</span>
          <div class="clear_b"></div>
        </div>
      </div>

      <div>
        <swiper class="mark-pic-box" :options="swiperOption" ref="mySwiper">
          <swiper-slide align="center">
            <template>
              <img src="../assets/img/banner1.jpg" class="w-100 clickable" @click="$router.push({path: '/details/1'})">
            </template>
          </swiper-slide>
          <swiper-slide align="center">
            <template>
              <img src="../assets/img/banner2.jpg" class="w-100 clickable" @click="$router.push({path: '/details/2'})">
            </template>
          </swiper-slide>
          <swiper-slide align="center">
            <template>
              <img src="../assets/img/banner3.jpg" class="w-100 clickable" @click="$router.push({path: '/details/3'})">
            </template>
          </swiper-slide>
          <swiper-slide align="center">
            <template>
              <img src="../assets/img/banner4.jpg" class="w-100 clickable" @click="$router.push({path: '/details/4'})">
            </template>
          </swiper-slide>
        <div class="swiper-pagination"  slot="pagination"></div>
      </swiper>
      <div style="padding: 40px 0 60px">
        <x-row>
          <x-col :span="8" align="center">
            <div style="width:380px;overflow:hidden;position: relative;height:160px">
              <img src="../assets/img/mini-banner2.png" alt="" :class="curIndex == 2 ? 'w-100 clickable ative':'w-100 clickable'" @click="toSwiper(2)">
            </div>
            <div class="inner-text">联名款</div>
          </x-col>
          <x-col :span="8" align="center">
            <div style="width:380px;overflow:hidden;position: relative;height:160px">
              <img src="../assets/img/mini-banner3.png" alt="" :class="curIndex == 3 ? 'w-100 clickable ative':'w-100 clickable'" @click="toSwiper(3)">
            </div>
            <div class="inner-text">静音款</div>
          </x-col>
          <x-col :span="8" align="center">
            <div style="width:380px;overflow:hidden;position: relative;height:160px">
              <img src="../assets/img/mini-banner4.png" alt="" :class="curIndex == 4 ? 'w-100 clickable ative':'w-100 clickable'" @click="toSwiper(4)">
            </div>
            <div class="inner-text">RGB款</div>
          </x-col>
        </x-row>
      </div>
      </div>

      <div class="banner">
        <img src="../assets/img/banner.jpg" class="w-100" alt="">
      </div>
      <div class="content">
        <div class="title">
          外设天下 & <span>REALFORCE</span>
        </div>
      </div>
      <div class="pos_r w-100" style="height:400px">
        <div class="content">
          <div>
            <div class="box-title">外设天下在中国举办了REALFORCE 新品品宣会</div>
          </div>
          <div>
            <x-row :gutter="30">
              <x-col :span="12">
                <img @click="$toweb('https://www.wstx.com/p-26169-1')" class="w-100 clickable mousehover" src="../assets/img/img1.jpg" alt="">
              </x-col>
              <x-col :span="12">
                <img @click="$toweb('https://www.wstx.com/p-26169-1')" class="w-100 clickable mousehover" src="../assets/img/img2.jpg" alt="">
              </x-col>
            </x-row>
          </div>
        </div>
      </div>
    </div>

    <div class="main-box">
      <div class="pos_r w-100" style="height:820px;margin-top:100px">
      <div class="content">
        <div align="center">
          <div class="box-title">专业的媒体平台及新媒体传播矩阵</div>
        </div>
      </div>
      <div class="content" style="width:760px">
        <div>
          <img @click="$toweb('https://www.wstx.com/')" src="../assets/img/wstx.jpg" class="w-100 clickable mousehover" alt="">
        </div>
        <div style="margin-top:30px">
          <x-row :gutter="30">
              <x-col :span="12">
                <img class="w-100" src="../assets/img/right1.jpg" alt="">
                <img style="margin-top:12px" class="w-100" src="../assets/img/right2.jpg" alt="">
              </x-col>
              <x-col :span="12">
                <img class="w-100" src="../assets/img/left1.jpg" alt="">
              </x-col>
          </x-row>
        </div>
      </div>
    </div>
    </div>
    

    <div class="content" style="padding-bottom: 90px">
      <div align="center">
        <div class="box-title" style="margin-bottom: 0;">线上电商及线下实体销售网络</div>
        <div class="icon-text">
          <img src="../assets/icons/icon.png" alt="" >授权经销商
        </div>
      </div>
      <div class="content">
        <x-row>
          <x-col :span="16">
            <div class="blackbtn">线上</div>
            <div class="link">
              <x-row>
                <x-col :span="10">
                  <span class="clickable underline" @click="$toweb('https://realforce.tmall.com/')">REALFORCE天猫旗舰店</span>
                  <span>REALFORCE京东自营旗舰店</span>
                  <span>REALFORCE京东旗舰店</span>
                  <span>REALFORCE开励天猫专卖店</span>
                  <span>外设天下京东旗舰店</span>
                  <span>鼎赞数码天猫专营店</span>
                  <span>景兰电竞外设天猫专营店</span>
                  <span>绮川数码天猫专营店</span>
                  <span>信驰数码天猫专营店</span>
                  <span>景兰电竞外设淘宝店</span>
                  <span>军曹の宅窝淘宝店</span>
                </x-col>
                <x-col :span="10">
                  <span>书剑极淘宝店</span>
                  <span>外设天下淘宝商城</span>
                  <span>欣礼坊淘宝店</span>
                  <span>卓臣科技淘宝店</span>
                  <span>尚岑电竞外设淘宝店</span>
                  <span>考拉海购</span>
                  <span>装备前线</span>
                  <span>分期乐APP</span>
                  <span>唯物APP</span>
                  <span>得物APP</span>
                </x-col>
              </x-row>
            </div>
          </x-col>
          <x-col :span="8">
            <div class="blackbtn">线下</div>
            <div class="link">
              <x-row>
                <x-col :span="10">
                  <span>北京卓威芳华</span>
                  <span>北京联合丽创</span>
                  <span>北京指尖电竞</span>
                  <span>长春忆人</span>
                  <span>杭州绮川</span>
                  <span>杭州卓臣</span>
                  <span>南京宁诺</span>
                  <span>青岛火星元素</span>
                </x-col>
                <x-col :span="12">
                  <span>（北京市海淀区）</span>
                  <span>（北京市海淀区）</span>
                  <span>（北京市朝阳区）</span>
                  <span>（长春市朝阳区）</span>
                  <span>（杭州市西湖区）</span>
                  <span>（杭州市西湖区）</span>
                  <span>（南京市宣武区）</span>
                  <span>（青岛市市北区)</span>
                </x-col>
              </x-row>
            </div>
          </x-col>
        </x-row>
      </div>
    </div>

    <div class="content">
      <div align="center">
        <div class="box-title" style="margin-bottom: 0;">售后联系方式</div>
      </div>
      <div class="footer-text">
        北京恩荣科技有限公司
        <br/>全国统一咨询电话：18612095732
        <br/>服务时间：周一 ~ 周五，上午9：00-12：00，下午13：30-17：30，国家法定节假日除外。
      </div>
    </div>
    <div class="content shouhoutext">
      <x-row>
        <x-col :span="6">· 售后所需信息
<br/>需要提供键盘型号及序列号。</x-col>
      </x-row>

      <x-row>
        <x-col :span="6">· 售后寄回步骤</x-col>
      </x-row>

      <x-row>
        <x-col :span="6">1.只接受质保期内售后寄回</x-col>
        <x-col :span="6">2.先电话或微信联系沟通（微信号同售后电话号）</x-col>
        <x-col :span="12">3.机器送修时请提供以下信息
                        <br/>- 购买日期、购买渠道以及相关订单信息
                        <br/>- 故障详情描述
                        <br/>- 真实有效的回寄地址、收件人姓名及联系电话
                        <br/>- 需包装及配件齐全，如果换过键帽请在寄出前换回原装键帽</x-col>
      </x-row>
    </div>

  </div>
</template>
 
<script>
export default {
  data() {
    var _this = this;
    return {
      swiperOption: {
            // initialSlide: 1,
            // loop: true,
            pagination: {
              el: ".swiper-pagination",
            },
            on:{
              slideChange: function(){
                console.log(this.activeIndex)
                _this.curIndex = (this.activeIndex + 1)
              },
            }
        },
        curIndex:1,
    }
  },
  methods: {
   toSwiper(index){
     this.curIndex = index;
     this.$refs.mySwiper.swiper.slideTo(index - 1, 1000, false)
   }
  },
  mounted() {
    
  },
};
</script>

<style scoped>
div{
  box-sizing: border-box;
}

.page{
  max-width: 2000px;
  min-width: 1200px;
  margin: 0 auto;
}
.bg {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.clickable {
  cursor: pointer;
  transition: all .4s;
}
.banner{
  text-align: center;
}
.title{
  font-size: 46px;
  line-height: 80px;
  margin: 50px 0 80px;
  color: #000000;
  border-bottom: solid 3px #D60000;
}
.title span{
  color: #D60000;
}
.content{
  width: 1000px;
  margin: 0 auto;
}
.gary-bg{
  background-color: #F0F0F0;
  height: 600px;
  width: 1700px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
.gary-bg-right{
  background-color: #F0F0F0;
  height: 1000px;
  width: 1700px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
}
.pos_r{
  position: relative; 
}
.w-100{
  width: 100%;
}
.box-title{
  font-size: 18px;
  text-align: left;
  font-weight: 600;
  color: #fff;
  background-color: #353535;
  line-height: 40px;
  padding: 0 15px;
  border-top: solid 10px #D60000;
  margin-bottom: 60px;
}
.mousehover:hover{
  box-shadow: 0 0 0 3px rgba(0, 0, 0, .4);
}

.footer{
  width: 100%;
  background-color: #F0F0F0;
  margin-top: 100px;
  padding-bottom: 100px;
}
.icon-text{
  vertical-align: middle;
  position: relative;
  background-color: #000000;
  text-align: left;
  color: #fff;
  line-height: 36px;
  padding: 0 15px;
  margin-bottom: 60px;
}
.icon-text img{
  margin-right: 10px;
  vertical-align: middle;
  position: relative;
  left: 0;
  top: -3px;
}
.blackbtn{
  display: inline-block;
  background-color: #EAEAEA;
  color: #000;
  padding: 5px 10px;
  border-radius: 12px;
  margin-bottom: 40px;
  font-weight: 600;
}
.link span{
  display: block;
  font-size: 16px;
  line-height: 24px;
  margin: 30px 0;
}
.underline{
  text-decoration: underline;
}
.underline:hover{
  letter-spacing: 2px;
}
.main-box{
  max-width: 1920px;
  margin: 0 auto;
}
/* add */
.header-btn{
  line-height: 30px;
  padding: 0 20px;
  color: #fff;
  background-color: #C11920;
  border-radius: 4px;
  float: right;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 5px;
}
.header{
  padding: 40px 0;
}

.innerpic{
  width: 650px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%,0);
  opacity: 0.9;
  cursor: pointer;
}
.inner-text{
  font-size: 18px;
  line-height: 30px;
}
.ative{
  opacity: 1;
}
.lasttext{
  font-size: 16px;
  line-height: 40px;
  margin-bottom: 40px;
}
.shouhoutext{
  font-size: 14px;
  line-height: 30px;
  text-align: left;
  margin-bottom: 40px;
}
.footer-text{
  font-size: 16px;
  line-height: 40px;
  margin: 40px 0 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue